import { dictionary as CarvanaDesignTokens } from '@carvana/helios-styles/style-dictionary';

export const ui = {
  _ui: {
    chatPanel: {
      heightHeader: '4rem',
      heightNavigation: '5vh',
      heightMainContent: '56vh',
      zIndex: 1000,
    },
    homePanel: {
      maxHeightHero: '180px',
    },
    minHeightQuestionInput: '80px',
    maxHeightTotal: '704px', // hard limit by design team. Everything else must be bound to match.
    zIndexApp: 1301, // matches value from old ChatAI
  },
} as const;

/**
 * A Figma `Inner Aligned` border, which is not natively supported in css.
 * Using the `border` property will effect inner element sizing.
 * @param thickness
 * @param color
 * @param raw If true, ony the css value is returned. Otherwise the css property and value are returned
 * @returns
 */
export const innerAlignBorder = (thickness: string, color: string, inset = true, raw = false) => {
  const cssValue = `${inset ? 'inset' : ''} 0px 0px 0px ${thickness} ${color}`;
  return raw
    ? cssValue
    : `
      box-shadow: ${cssValue};
      -webkit-appearance: none;
      -webkit-box-shadow: ${cssValue};
  `;
};

/**
 * On focus styling
 */
export const focusBoxShadow = (
  focusVisible: typeof CarvanaDesignTokens.shadow.focusVisible,
  inset = false,
  raw = false,
) => {
  const cssValue = `${focusVisible
    .map(
      ({ x, y, blur, spread, color }: any) =>
        `${inset ? 'inset' : ''} ${x}px ${y}px ${blur}px ${spread}px ${color}`,
    )
    .join(',')}`;

  return raw ? cssValue : `box-shadow: ${cssValue};`;
};
